import { defaultYear } from "./DefaultYear";

export const buildRankingApiUrl = ( {
    state = 'all',
    sortBy = 'overall',
    type = null,
    direction = 'asc',
    year = defaultYear,
    limit = -1,
    speechCode = null,
    viewpoint = null,
    tuition = null,
    enrollment = null,
    conference = null,
    zip = null,
    distance = null
} ) => {
    let url = `/api/rankings?year=${year}&limit=${limit}&sort_by=${sortBy}_score&direction=${direction}`;

    if (type) {
        url += `&type=${type}`;
    }

    if (state !== 'all') {
        url += `&state=${state}`;
    }

    if (speechCode) {
        url += `&speech_code=${speechCode}`;
    }

    if (viewpoint) {
        url += `&viewpoint=${viewpoint}`;
    }

    if (tuition) {
        url += `&tuition=${tuition}`;
    }

    if (enrollment) {
        url += `&enrollment_size=${enrollment}`;
    }

    if (conference) {
        url += `&conference=${encodeURIComponent(conference)}`;
    }

    if (zip && distance) {
        url += `&zip=${encodeURIComponent(zip)}&distance=${distance}`;
    }

    return url;
}
